﻿import { Remote, IRemoteOptions, IRemoteHandler } from "./remote";
import Element from "../../utilities/element";
import Ajax from "./ajax";

export class RemoteTriggerHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    var shouldHandle = $element.isEnabled() && $element.is(Remote.triggerWireup);
    if (!shouldHandle)
      return false;

    options.$triggeringEvent?.preventDefault();

    options.type = $element.data('method') || 'get';
    options.url = options.url || $element.attr('href') || $element.data('url');
    let element = new Element($element);
    var name = $element.data('remote-name-override') || element.name();
    var value = $element.data('remote-value-override') || element.value();
    var data = {}
    data[name] = value;

    options.url = options.url || $element.data('url');
    options.data = data;

    Ajax.execute($element, options);

    return true;
  }
}
